<style>
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  a {
    color: #333333;
    text-decoration: none;
  }
  a:hover{
    color: #1890ff;
    text-decoration: none;
  }
.hdNews {
  padding: 12px 24px;
  margin-bottom: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}
.content_body li {
  line-height: 28px;
  padding: 0 0 0 10px;
}
.clear {
  clear: both;
}
</style>
<template>
<div>
  <HeaderView></HeaderView>
  <NavigateView></NavigateView>
  <BannerView></BannerView>
    <div v-bind:style="{minHeight: height+'px'}" style="width: 980px; margin: 0 auto;" >
    <template>
      <div class="content_body">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item style="padding-top: 8px;">集中议价</el-breadcrumb-item>
          <el-breadcrumb-item style="padding-top: 8px;">业务答疑</el-breadcrumb-item>
          <el-button key="点我留言" size="mini" style="float: right;" @click="question">点我留言</el-button>
        </el-breadcrumb>
        <el-divider content-position="left"></el-divider>
        <ul>
          <div class="hdNews" v-for="(w, key) in queryform.data">
            <li style="width:860px; float:left; word-wrap: break-word; " :style="{background:`url(${liBackgroundImg}) no-repeat left center`}">
              <a :title="w.title">{{w.content}}</a>
            </li>
            <div style="width:100%; float:left;">
              <span style="font-family: 微软雅黑, 'Microsoft YaHei'; font-size: 14px;">{{w.reply||`其他方式回复`}} </span>
            </div>
            <div style="width:100%; float:left;">
              <p style="font-size:10px; text-align:right;">发表时间：{{w.createTime}}</p>
            </div>
            <div class="clear"></div>
            <!-- <div style="border-bottom:1px dashed #d6d6d6;"></div> -->
          </div>
        </ul>
        </div>

      <el-pagination @size-change="(val) => handlePagination(null, val, 'queryform')" @current-change="(val) => handlePagination(val, null, 'queryform')" @prev-click="(val) => handlePagination(val, null, 'queryform')" @next-click="(val) => handlePagination(val, null, 'queryform')"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="queryform.pageNo"
        :page-sizes="queryform.pageSizes" :page-size="queryform.pageSize" :total="queryform.total">
      </el-pagination>
    </template>
    </div>


  <!-- 用户设置报价加密密码 -->
  <el-dialog title="发表留言" :visible.sync="dialogVisible" width="600px" top="145px">
    <el-form key="form" status-icon :model="form" :rules="formRules" ref="form" label-width="100px" class="demo-form-inline">
      <!-- <el-form-item label="类别" prop="ctgId">
        <el-select v-model="form.ctgId" placeholder="请选择留言类别">
          <el-option
            v-for="item in categoryList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item label="内容" prop="content">
        <el-input type="textarea" v-model="form.content" maxlength="500" rows="4" placeholder="请输入留言内容"  show-word-limit></el-input>
      </el-form-item>
      <el-row type="flex">
        <el-col :span="12">
          <el-form-item label="联系人" prop="participants">
            <el-input v-model="form.participants" maxlength="20" placeholder="请输入联系人姓名" show-word-limit></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="部门/职位" prop="positions">
            <el-input v-model="form.positions" maxlength="20" placeholder="请输入联系人姓名" show-word-limit></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex">
        <el-col :span="12">
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="form.phone" maxlength="11" placeholder="请输入联系人电话" show-word-limit></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电子邮箱" prop="email">
            <el-input v-model="form.email" placeholder="请输入联系人电子邮箱地址"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex">
          <el-col :span="10">
            <el-form-item label="验证码" prop="captcha">
              <el-input v-model="form.captcha" placeholder="请输入验证码" autocomplete="off" autocapitalize="off"       spellcheck="false"></el-input>
            </el-form-item>
          </el-col>
          <img ref="form.captcha" style="width: 100px; height: 55px" :src="captchaUrl" @click="changeCaptcha" />
        </el-row>

    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">&emsp;取&emsp;消&emsp;</el-button>
        <el-button :loading="submitButtonLoading" type="primary" size="small" @click="saveGuestbook('form')">&emsp;确&emsp;定&emsp;</el-button>
      </span>
    </template>
  </el-dialog>
  <FooterView></FooterView>
</div>

</template>
<script>
  export default {
    name: 'businessQA',
    data(){
      return {
        active: 0,
        height: 0,
        operate: false,
        captchaUrl: '',
        dialogVisible: false,
        dialogApplyVisible: false,
        submitButtonLoading: false,
        form: { ctgId: '', title: '', content: '', captcha: '', positions: '', phone: '', email: '', participants: '', },
        formRules: {
          ctgId: [ { required: true, message: '请选择留言类别', trigger: 'blur' }, ],
          content: [ { required: true, message: '请输入留言内容', trigger: 'blur' }, ],
          participants: [ { required: true, message: '请输入联系人姓名', trigger: 'blur' }, ],
          phone: [{ required: true, message: '请输入联系人电话号码', trigger: 'blur' }, ],
          email: [
            { required: true, message: '请输入电子邮箱地址', trigger: 'blur' },
            { pattern: /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/, message: '输入的电子邮箱地址不规范', trigger: 'blur' }
          ],
          captcha: [ { required: true, message: '请输入验证码', trigger: 'blur' }, ]
        },
        queryform: {
          data: [], total: 0, pageNo: 1, pageSize: 10, pageSizes: [10, 20, 50, 100], fn: 'page',
        },
        categoryList: [],
        liBackgroundImg: process.env.VUE_APP_API_URL + 'r/cms/www/default/img/index/li_bg.jpg',
      };
    },
    mounted(){
      if(!sessionStorage[this.$route.path]){
        window.location.href = process.env.VUE_APP_API_URL;
      }
      //动态设置内容高度 让footer始终居底   header+footer的高度是100
      this.height = document.documentElement.clientHeight - 350;
      //监听浏览器窗口变化　
      window.onresize = ()=> {this.height = document.documentElement.clientHeight - 350}
    },
    created() {
      this.page();
    },
    watch:{},
    methods: {
      initView(){
        setTimeout(() => {
          this.submitButtonLoading = true;
          new Promise((resolve, reject) =>{
            return this.$api.memberApi.getDeclareResult({stype: 'DECLARE'}).then(data => {
              if(200 === data.status){
                if(200 === data.data.code){
                  let array = JSON.parse(data.data.data);
                  if(0 < array.length){
                    this.declareResult = array[0];
                    resolve(true);
                  }
                }else if(403 === 200){
                  this.goLogin(response.data.msg);
                }else{
                  this.$message({ message: data.data.data, offset: 200, type: 'error' });
                }
              }
              resolve(false);
            })
          }).then(res =>{
            if(res){
              this.page();
            }
          }).catch(err => {
            console.info(err);
          })
        })
      },
      handleClick(tab, event){
        if(this[event]){
          this[event].call(this, tab);
        }
      },
      getRowKeys(row) {
        return row.id
      },
      handlePagination(pageNo, pageSize, obj){
        if(this[obj] && typeof this[obj] !== 'function'){
          if(pageNo){
            this[obj].pageNo = pageNo;
          }
          if(pageSize){
            this[obj].pageSize = pageSize;
          }
          this[this[obj].fn] && this[this[obj].fn]();
        }
      },
      toDateString: function(time, format){
        let date = new Date(time || new Date())
        ,ymd = [this.digit(date.getFullYear(), 4), this.digit(date.getMonth() + 1), this.digit(date.getDate())]
        ,hms = [this.digit(date.getHours()), this.digit(date.getMinutes()), this.digit(date.getSeconds())];
        format = format || 'yyyy-MM-dd HH:mm:ss';
        return format.replace(/yyyy/g, ymd[0]).replace(/MM/g, ymd[1]).replace(/dd/g, ymd[2]).replace(/HH/g, hms[0]).replace(/mm/g, hms[1]).replace(/ss/g, hms[2]);
      },
      page: function(){
        this.submitButtonLoading = true;
        let { pageNo, pageSize } = this.queryform;
        this.$api.memberApi.guestbookPage({ pageNo, pageSize}).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              this.queryform.data = [];
              JSON.parse(response.data.data).forEach((d, index, arr)=>{
                if(d.confirmed){
                  d.fn = 'true';
                  d.btnType = 'text';
                  d.operate = '已报名';
                }
                this.queryform.data.push(d);
              });
              this.queryform.total = response.data.count;
            }else{
              callback(new Error(response.data.msg));
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      },
      question(){
        setTimeout(() => {
          this.submitButtonLoading = true;
          new Promise((resolve, reject) =>{
            // return this.$api.memberApi.guestbookCtgList().then(data => {
            //   if(200 === data.status){
            //     if(200 === data.data.code){
            //       let array = JSON.parse(data.data.data);
            //       if(0 < array.length){
            //         this.categoryList = array;
            //         resolve(true);
            //       }
            //     }else if(403 === response.data.code){
            //       this.goLogin(response.data.msg);
            //     }else{
            //       this.$message({ message: data.data.data, offset: 200, type: 'error' });
            //     }
            //   }
            //   resolve(false);
            // })
            resolve(1);
          }).then(res =>{
            if(res){
              //显示用户问题form
              this.dialogVisible = true;
              this.submitButtonLoading = false;
              this.captchaUrl = this.getCaptchaUrl();
            }
          }).catch(err => {
            console.info(err);
          })
        })
      },
      saveGuestbook(formName){
        this.$refs[formName].validate((valid) => {
          if(valid){
            let objson = {};
            Object.assign(objson, this.form);
            this.submitButtonLoading = true;
            this.$api.memberApi.saveGuestbook(objson).then(response => {
              this.submitButtonLoading = false;
              if(response.status === 200){
                if(response.data.code === 200){
                  this.$message({ message: response.data.data, offset: 200, type: 'success' });
                  this.dialogVisible = false;
                  this.submitButtonLoading = false;
                  this.$refs[formName].resetFields();
                  this.page();
                }else{
                  this.captchaUrl = this.getCaptchaUrl();
                  this.$message({ message: response.data.data, offset: 200, type: 'error' });
                }
              }else{
                this.$message.error(`服务忙，请稍后再试`);
              }
            }).catch(error => {
              this.submitButtonLoading = false;
            });
          } else {
            this.submitButtonLoading = false;
          }
        });
      },
      clearValidate(formName){
        this.$refs[formName].clearValidate();
      },
      changeCaptcha: function() {
        this.captchaUrl = this.getCaptchaUrl();
      },
      getCaptchaUrl: function() {
        this.form.captcha = '';
        return process.env.VUE_APP_API_URL+'captcha.svl?d='+new Date().getTime()
      },
      goLogin() {
        this.$message({ message: '登录过期，请重新登录账户！', offset: 200, type: 'error' });
        setTimeout(() => {
          this.submitButtonLoading = false;
          window.location.href = process.env.VUE_APP_API_URL;
        }, 2000)
      }
    }
  }
</script>
<style>
  .el-dialog__footer {
    text-align: center;
  }
  .el-divider-horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 12px 0;
  }
  .upload-left{
    text-align: left;
  }

  .register-wrapper-div{
    padding-top:10px;
    width: 750px;
    margin: 0 auto;
    background-color: #f8f8f8;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-radio{
    margin-right: 0;
  }
  .el-checkbox{
    margin-right: 5px;
  }
  .el-radio--mini.is-bordered {
    margin: 2px 0;
  }
  .el-divider--horizontal {
    margin: 10px 0;
  }
  .el-collapse-item__content{
    padding-bottom: 10px;
  }
  .el-alert--info.is-light{
    width: auto;
    height: 65%;
    margin-right: 15px;
  }
  .el-tag--plain{
    width: 130px;
    text-align: center;
    border: 0px solid #fff;
  }
  .radio-br{
    width: 75%
  }
  .radio-auto{
    float: left;
    margin-right: 10px;
  }
  .assess-score {
    margin-right: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/views/Member/BusinessQA.vue